module.exports = __webpack_public_path__ + "fr_FR-download-010608.webp";